import { observer } from "mobx-react";
import { useEffect, useState } from "react";

import ProjectsContainer from "../components/ProjectsContainer/ProjectsContainer";
import ProjectsGroupTitle from "../components/ProjectsGroup/ProjectsGroupTitle/ProjectsGroupTitle";
import { ProjectsActiveRow } from "./ProjectsActiveRow/ProjectsActiveRow";
import ProjectsFilter from "../components/ProjectsFilter/ProjectsFilter";

import AppStore from "AppStore";

import { NO_PROJECTS_COMMENT_FOR_ACTIVE } from "../../Projects/ProjectsConstants";

import "./ProjectsActive.scss";

const ProjectsActive = observer(({ projects, isMobile }) => {
  const [expandedTypes, setExpandedTypes] = useState([]);
  const [openDropdown, setOpenDropdown] = useState(null);

  useEffect(() => {
    if (projects?.length) {
      const projectTypes = new Set(projects.map((project) => project.type));
      setExpandedTypes(Array.from(projectTypes));
    }
  }, [projects]);

  const toggleType = (type) => {
    if (expandedTypes.includes(type)) {
      setExpandedTypes(expandedTypes.filter((t) => t !== type));
    } else {
      setExpandedTypes([...expandedTypes, type]);
    }
  };

  const filteredProjects = AppStore.reportStatusFilter 
    ? AppStore.getFilteredActiveProjects() 
    : projects;

  const sortedProjects = filteredProjects?.slice().sort((a, b) => {
    const dateA = new Date(a.startDatetime || 0);
    const dateB = new Date(b.startDatetime || 0);
    return dateB - dateA;
  });

  const groupedProjects = sortedProjects?.reduce((acc, project) => {
    const type = project.type;
    if (!acc[type]) {
      acc[type] = [];
    }
    acc[type].push(project);
    return acc;
  }, {});

  let indexToExpand = sortedProjects?.findIndex((project) => project.reports?.find((report) => report.status === "ready"));
  if (indexToExpand < 0 && sortedProjects?.length) indexToExpand = 0;

  const toggleDropdown = (type) => {
    setOpenDropdown(openDropdown === type ? null : type);
  };

  if (!filteredProjects || filteredProjects.length === 0) {
    return (
      <ProjectsContainer className="projects-active" hasProjects={false} emptyComment="Нет проектов с выбранным статусом отчетов" />
    );
  }

  return (
    <ProjectsContainer className="projects-active" hasProjects={projects?.length > 0} emptyComment={NO_PROJECTS_COMMENT_FOR_ACTIVE}>
      {Object.entries(groupedProjects).map(([type, typeProjects]) => {
        const cities = AppStore.getCitiesForType(typeProjects);
        const hasBotsInType = typeProjects.some(project => project.bots);
        const filteredTypeProjects = AppStore.getFilteredProjects('active', type, typeProjects);
        const shouldShowFilter = cities.length > 2;

        if (filteredProjects.length === 0) return null;

        return (
          <div key={type}>
            <div className="projects-active__row">
              <div className="projects-active__row-container">
                <div className="projects-active__row-header" onClick={() => toggleType(type)} >
                  <ProjectsGroupTitle type={type} count={filteredTypeProjects.length} expandedTypes={expandedTypes.includes(type)} isMobile={isMobile} />
                </div>
              </div>
              {shouldShowFilter &&
                <ProjectsFilter
                  cities={cities}
                  selectedCities={AppStore.selectedCities.active}
                  type={type}
                  typeProjects={typeProjects}
                  onChange={(type, city) => AppStore.setSelectedCity('active', type, city)}
                  isOpen={openDropdown === type}
                  onToggle={() => toggleDropdown(type)}
                  isMobile={isMobile}
                />
              }
            </div>
            <div className={`projects-active__row-reports ${expandedTypes.includes(type) ? "expanded" : ""}`}>
              {filteredTypeProjects.length > 0
                ? filteredTypeProjects.map((project, i) => <ProjectsActiveRow key={i} project={project} initialExpanded={i === indexToExpand} hasBotsInType={hasBotsInType} isMobile={isMobile} />)
                : <div className="projects-active__no-results">Нет результатов</div>
              }
            </div>
          </div>
        );
      })}
    </ProjectsContainer>
  );
});

export default ProjectsActive;
